import { SET_INTEGRATIONS, SET_INTEGRATION_BUSY, SHOW_ERROR } from "./Types";
import api from "../../api";

export function fetchIntegrations() {
  return async function (dispatch) {
    try {
      dispatch({ type: SET_INTEGRATION_BUSY, busy: true });

      const result = await api.integration.getAll();

      if (result.success && result.data) {
        const { subscribedZips, ...data } = result.data;
        dispatch({ type: SET_INTEGRATIONS, data, subscribedZips: subscribedZips || [] });
      } else {
        dispatch({ type: SHOW_ERROR, message: result.error });
      }
    } catch (e) {
      console.error(e);
      dispatch({ type: SHOW_ERROR, message: e });
    } finally {
      dispatch({ type: SET_INTEGRATION_BUSY, busy: false });
    }
  };
}

export function saveIntegration(type, payload) {
  return async function (dispatch, getState) {
    try {
      const result = await api.integration.save(type, payload);

      if (result.success && result.data) {
        const { data } = getState().integration;
        const updated = { ...data, [type.toLowerCase()]: result.data };
        const { subscribedZips } = getState().integration;
        dispatch({ type: SET_INTEGRATIONS, data: updated, subscribedZips });
      }

      return result;
    } catch (e) {
      console.error(e);
      return { success: false, error: e?.message || "Unknown error" };
    }
  };
}

export function verifyIntegration(type) {
  return async function () {
    try {
      return await api.integration.verify(type, {});
    } catch (e) {
      console.error(e);
      return { success: false, error: e?.message || "Unknown error" };
    }
  };
}
